import Header from '../../components/Header'
import Sidebar from '../../components/Sidebar'
import { Col, Row } from 'react-bootstrap'
import PrescriptionForm from './PrescriptionForm'
import PrescriptionPDF from './PrescriptionPDF'
import { useForm, useWatch } from 'react-hook-form'
import { useContext, useEffect, useRef } from 'react'
import { ProfileContext } from "../../context/ProfileContext";
import { IMAGE_URL } from '../../API'

const Prescription = () => {
  const pdfRef = useRef(null);
  const { personalInfo } = useContext(ProfileContext);
  const methods = useForm({
    defaultValues: {
      patient_name: "",
      age: "",
      gender: "",
      diagnosis: "",
      doctor_name: "",
      gmc_no: "",
      signature: "",
      medicines: [
        {
          medicine_name: "",
          dosage: "",
          frequency: "",
          duration: "",
          instructions: "",
        },
      ],
    },
  });

  useEffect(() => {
    if (personalInfo) {
      methods.setValue("doctor_name", personalInfo.name || "");
      methods.setValue("gmc_no", personalInfo.gmc_number || "");
      methods.setValue("signature", (IMAGE_URL + personalInfo.signature) || "");
    }
  }, [personalInfo]);

  const { control } = methods;
  const liveData = useWatch({ control });

  return (
    <div className="container-fluid">
      <Header />
      <div className="row">
        <Sidebar />
        <div className="col-9 main-dash-left">
          <section className="back-dashboard-sec comn-dashboard-page">
            <Row className="align-items-start prescription-row">
              <Col md={6} className="prescription-left">
                <div className="notifi-list d-flex">
                  <div>
                    <h6 className="comm_page_heading">Prescription</h6>
                    <p className="comm_page_sub_heading">
                      Prescriptions authored by clinicians using consultation details, supporting safe and informed treatment decisions.
                    </p>
                  </div>
                </div>
                <PrescriptionForm methods={methods} pdfRef={pdfRef} />
              </Col>

              <Col md={6} className="prescription-right">
                <div className="pdf-scale-wrapper">
                  <PrescriptionPDF ref={pdfRef} data={liveData} />
                </div>
              </Col>
            </Row>
          </section>
        </div>
      </div>
    </div>
  )
}

export default Prescription